import React, { useState, useEffect, useRef } from "react";

import { Button, IconButton, TextField, Typography } from "@mui/material";
import {Box, Grid} from "@mui/material";
import api from "../api";

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import { milisecondsToTime, getTimeFromDate } from "../utils";
import CurrentPunchEntrySection from "./CurrentPunchEntrySection";

import logo from "../img/horo-text.png"
import moment from "moment";

import './EmployeePunch.css'

export const TimeEntry = ({section, item, onClick}) => {
    return <ListItem onClick={onClick} key={`item-${section}-${item.id}`}>
        <ListItemText primary={`${getTimeFromDate(item.open_time)} - ${getTimeFromDate(item.end_time)}`} secondary={item.note ? `Note: ${item.note}`: ""} />
    </ListItem>;
}

const EmployeePunch = (props) => {
    
    const [numberValue, setNumberValue] = useState("")
    const [user, setUser] = useState(null)
    const [sums, setSums] = useState([])
    const [punchEntries, setPunchEntries] = useState([])
    const [error, setError] = useState("")

    const handleGetEmployee = async (e) => {
        e.preventDefault()
        let res = await api.get("/employee_company/", {number:numberValue})
        
        // Si un user valide est retourne
        if (res.data.id) {
            setUser(res.data)
            const userId = res.data.id
    
            if (res.data.id) {
                getEntries(userId)
            }
            setError("")

        }
        else {
            setError("Le numéro d'employé est invalide")
        }
    }

    const unlogUser = () => {
        setUser(null)
        setSums([])
        setPunchEntries([])
        setNumberValue("")

        document.getElementById("employee-number-field").focus()
    }

    const getEntries = async (userId) => {
        let res = await api.get('/time_period/', {date: moment().toISOString()})
        let beginDate = res.data['begin_date']
        let endDate = res.data['end_date']

        res = await api.get('/punch_entries/', {employee:userId, end_date:endDate, begin_date:beginDate})
        setPunchEntries(res.data.entries_by_day)
        setSums(res.data.sums)
    }

    const deconnect = () => {
        localStorage.clear();
        window.location.reload();
        window.location.href="/"
    }

    
    return (
        <div className="employee-punch-container" >
            <div style={{backgroundColor:"var(--color-bg)", display:"block", margin:"auto",padding:" 0px 2px", textAlign:"left"}}>
                <Button onClick={deconnect} color="error" sx={{fontSize:"0.7em"}}>Déconnexion</Button>
            </div>
        <Box
            component="form"
            padding={"0px 10px"}
            alignContent="center"
            width={"100%"}
            justifyContent="center"
            margin={"20px auto"}
            textAlign="center"
            className="search-box"
            onSubmit={(e) => handleGetEmployee(e)}
        >
            <div style={{ display:"inline-flex", width:"100%"}}>
                <TextField
                    id="employee-number-field"
                    label="No. d'employé"
                    fullWidth
                    value={numberValue}
                    onChange={(e) => setNumberValue(e.target.value)}
                    autoFocus
                    helperText={error}
                    autoCapitalize="none"
                    autoComplete="off"
                    
                />
                <Button
                    color="success"
                    variant="contained"
                    sx={{ marginLeft:"20px"}}
                    onClick={handleGetEmployee}
                >Accéder</Button>

            </div>
        </Box>
        {user && 

        <Box
            component="form"
            padding={"10px 10px"}
            alignContent="center"
            width={"98%"}
            justifyContent="center"
            margin={"20px auto"}
            textAlign="center"
            onSubmit={(e) => handleGetEmployee(e)}
            backgroundColor="var(--color-bg-high)"
            borderRadius="20px"
            border="2px solid var(--color-primary)"
            height={"100%"}
            boxSizing="border-box"
            display="flex"
            flexDirection="column"
            position={"relative"}
            
        >
                    <Button style={{marginLeft:"auto", float:"right",fontSize:"x-large", position:"absolute", top:0, right:0}} color="error" onClick={unlogUser}>x</Button>

                    <div style={{ display:"inline-flex", width:"100%"}}>
                        <Typography style={{ margin:"auto", float:"right",fontSize:"x-large"}}>Bonjour <b>{user.name}</b></Typography>
                    </div>
                


                        <CurrentPunchEntrySection
                            getEntries={getEntries}
                            user={user}
                        />


                
                    <Typography variant="h6">Entrées passées:</Typography>
                    
                    <List
                        sx={{
                            width: '100%',
                            bgcolor: 'background.paper',
                            overflowY: 'scroll',
                            height:"100%",
                            position:"relative",
                            '& ul': { padding: 0 },
                        }}
                        subheader={<li />}
                        >
                        {Object.keys(punchEntries).map((key) => (
                            <li key={`section-${key}`}>
                            <ul>
                                <ListSubheader>{`${key} - ${sums[key]}`}</ListSubheader>
                                {punchEntries[key].map((item) => (
                                <TimeEntry
                                    section={key}
                                    item={item}
                                />
                                ))}
                            </ul>
                            </li>
                        ))}
                    </List>
                
        </Box>}
        </div>

    )
    
}
export default EmployeePunch